import { gsap } from 'gsap';
import '../styles/index.css';
import supportsWebP from 'supports-webp';

// Webp compatibility check

supportsWebP.then((supported) => {
  const bodyTag = document.body;
  if (supported) {
    bodyTag.classList.add('webp');
  } else {
    bodyTag.classList.add('no-webp');
  }
});

// Wheel

const wheel = document.getElementById('wheel');
const ticker = document.getElementById('ticker');
const wheelLogo = document.getElementById('logo-circle');
const centreWheel = document.getElementById('wheel-segments');
const hand = document.getElementById('hand-cursor');
const overlay = document.querySelector('.overlay');
const gameWheel = document.querySelector('.game-wheel__svg');
const lights = document.querySelector('.lights');
const indicator = gsap.timeline();
const spinWheel = gsap.timeline({ paused: true });

gsap.from(wheel, {
  transformOrigin: '50% 50%',
  scale: 0,
});
gsap.to(wheel, {
  duration: 1.5,
  rotation: 360,
  transformOrigin: '50% 50%',
  ease: 'power4.easeOut',
  scale: 1,
  onComplete() {
    gameWheel.classList.add('game-wheel--visible');
    ticker.classList.add('ticker--visible');
    ticker.classList.add('fade-in');
    wheelLogo.classList.add('logo-circle--visible');
    wheelLogo.classList.add('fade-in');
    hand.classList.add('hand--visible');
    hand.classList.add('fade-in');
    animateHand.play();
  },
});

const animateHand = gsap.fromTo(
  hand,
  {
    scale: 0.75,
  },
  {
    duration: 0.5,
    scale: 1,
    yoyo: true,
    repeat: -1,
    ease: 'none',
  }
);

spinWheel.to(centreWheel, {
  duration: 5,
  rotation: 2194,
  transformOrigin: '50% 50%',
  ease: 'power4.easeOut',
  onComplete() {
    setTimeout(() => {
      gsap.fromTo(
        lights,
        {
          webkitFilter: 'brightness(0.3)',
          filter: 'brightness(0.3)',
        },
        {
          duration: 0.5,
          webkitFilter: 'brightness(4)',
          filter: 'brightness(4)',
          yoyo: true,
          repeat: -1,
          ease: 'none',
        }
      );
      setTimeout(() => {
        overlay.classList.add('overlay--visible');
        overlay.classList.add('fade-in');
        gameWheel.classList.add('dim');
        centreWheel.style.willChange = 'auto';
      }, 1000);
    }, 500);
  },
});

wheelLogo.addEventListener('click', function () {
  hand.style.display = 'none';
  centreWheel.style.willChange = 'transform';
  spinWheel.play().timeScale(1);
  indicator.timeScale(1).seek(0);
});

// Track events

(function () {
  document.querySelectorAll('[data-message]').forEach((element) => {
    element.addEventListener('click', () => {
      window.parent.postMessage(element.dataset.message, '*');
    });
  });
})();
